import { Component } from "react";

export class Graphics extends Component {
  render() {
    return (<div></div>);
  }
}
